/* import __COLOCATED_TEMPLATE__ from './version-bubble.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();